import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotRecommend() {
  const [expandedId, setExpandedId] = useState<number>(hotComics[0].id);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3">
              🔥 热门推荐
            </h2>
            <p className="text-foreground-600 text-base max-w-xl mx-auto">
              精选全站最受欢迎的韩国漫画，每一部都是读者口碑之作
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {hotComics.map((comic) => {
              const isExpanded = expandedId === comic.id;
              return (
                <div
                  key={comic.id}
                  onMouseEnter={() => setExpandedId(comic.id)}
                  className={`relative group cursor-pointer rounded-2xl overflow-hidden transition-all duration-500 ease-out ${
                    isExpanded ? 'md:col-span-1 scale-100' : 'md:scale-[0.97]'
                  }`}
                  style={{ aspectRatio: '3/4' }}
                >
                  <img
                    src={comic.imageUrl}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                      {comic.category}
                    </span>
                    <h3 className="text-xl md:text-2xl font-bold text-background-50 mb-1">
                      {comic.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-background-50/80 mb-2">
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-accent-500"></i> {comic.rating}
                      </span>
                      <span>{comic.views} 阅读</span>
                      <span>{comic.chapters}话</span>
                    </div>
                    <p
                      className={`text-sm text-background-50/70 leading-relaxed transition-all duration-500 ${
                        isExpanded ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0 overflow-hidden'
                      }`}
                    >
                      {comic.description}
                    </p>
                  </div>

                  <Link
                    to={`/article/${comic.slug}`}
                    className="absolute inset-0 z-10"
                    aria-label={comic.title}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}